<template>
  <div>
    <cabecalho :title="$t('ACADEMICO_MATRICULAS.CONTATOS')" title_type="body" />
    <div class="col-xl-12 flex mb-4" style="display: flex;">
      <input-checkbox
        disabled
        :title="$t('GERAL.MARCAR_TODOS')"
        v-model="aluno.mesmoContatoResponsavelFinanceiro"
        :aria-label="$t('GERAL.MARCAR_TODOS')"
        aria-describedby="checkbox-label"
      />
      <span>Mesmo contato do resposável financeiro</span>
    </div>
    <b-table
      :items="aluno.contatos"
      :fields="campos"
      :empty-text="$t('GERAL.NENHUM_REGISTRO')"
      head-variant="light"
      stacked="md"
      responsive
      show-empty
      striped
      hover
    >
    </b-table>
  </div>
</template>
<script>
// Components:
import { Cabecalho } from '@/components/headers/index';
import { InputCheckbox } from '@/components/inputs';

export default {
  props: {
    aluno: { type: Object, default: Object },
  },
  components: { Cabecalho, InputCheckbox },
  data() {
    return {
      campos: [
        {
          key: 'nome',
          label: 'Nome',
          formatter: (value) => {
            return value ? value : '-';
          },
        },
        {
          key: 'descricao',
          label: 'Descrição',
        },
        {
          key: 'tipoContatoDescricao',
          label: 'Tipo de Contato',
        },
        {
          key: 'principal',
          label: 'Principal',
          formatter: (value) => {
            return value ? 'Sim' : 'Não';
          },
        },
      ],
    };
  },
  methods: {},
};
</script>
